'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = setVolume;

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _store = require('../../../store');

var _store2 = _interopRequireDefault(_store);

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setVolume(playerId, volume) {
  if (process.env.NODE_ENV !== 'production') {
    (0, _invariant2.default)(volume >= 0 && volume <= 1, 'Action:setVolume: The Volume can not be larger than 1, and can not be less than 0.  volume: ' + volume);
  }
  var muted = volume === 0 ? true : false;
  _store2.default.getPlayerInstance(playerId).volume = volume;
  _store2.default.getPlayerInstance(playerId).muted = muted;

  return {
    type: _constants.SET_VOLUME,
    muted: muted,
    playerId: playerId,
    volume: volume
  };
}
module.exports = exports['default'];